<template>
  <label :class="{'checkbox-label': true, 'label-link': link}">
    <input type="checkbox" v-model="checked" @click.stop @change="onChange"/>
    <span class="checkbox-custom" :class="color || 'blue'"></span>
    <div v-if="$slots.default" class="label">
      <slot></slot>
    </div>
  </label>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    value: Boolean,
    color: String,
    text: String,
    link: Boolean
  },
  data () {
    return {
      checked: this.value
    }
  },
  methods: {
    onChange () {
      this.$emit('change', this.checked)
    }
  },
  watch: {
    value (newValue) {
      this.checked = newValue
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.checkbox-label {
  display: block;
  position: relative;
  margin: auto;
  cursor: pointer;
  font-size: 14px;
  line-height: 25px;
  min-height: 25px;
  min-width: 18px;
  clear: both;

  &.label-link {
    max-width: calc(100% - 21px);
  }

  .label {
    width: calc(100% - 30px);
    margin-left: 30px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkbox-custom {
    position: absolute;
    top: 0;
    left: 0;
    height: 18px;
    width: 18px;
    margin-top: 3px;
    background-color: $white;
    border-radius: 4px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.15s ease-out;
    -moz-transition: all 0.15s ease-out;
    -ms-transition: all 0.15s ease-out;
    -o-transition: all 0.15s ease-out;
    border: 2px solid $checkbox-border;
  }

  input:checked ~ .checkbox-custom {
    border-radius: 4px;
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }

  input:checked ~ .checkbox-custom.blue {
    background-color: $blueberry;
    border: 2px solid $blueberry;
  }

  input:checked ~ .checkbox-custom.purple {
    background-color: $magento;
    border: 2px solid $magento;
  }

  .checkbox-custom::after {
    position: absolute;
    content: "";
    left: 9px;
    top: 9px;
    height: 0;
    width: 0;
    border-radius: 4px;
    border: solid $white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(0deg) scale(0);
    -ms-transform: rotate(0deg) scale(0);
    transform: rotate(0deg) scale(0);
    opacity: 1;
    transition: all 0.15s ease-out;
    -webkit-transition: all 0.15s ease-out;
    -moz-transition: all 0.15s ease-out;
    -ms-transition: all 0.15s ease-out;
    -o-transition: all 0.15s ease-out;
  }

  input:checked ~ .checkbox-custom::after {
    -webkit-transform: rotate(45deg) scale(1);
    -ms-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
    opacity: 1;
    left: 4px;
    top: 0;
    width: 6px;
    height: 12px;
    border: solid $white;
    border-width: 0 2px 2px 0;
    background-color: transparent;
    border-radius: 0;
  }
}
</style>
